<template>
  <div class="auth-secondary-page  container">
    <div class="auth-secondary-page__content  container-inner">
      <template v-if="isAgent && !token">
        <AuthAgentLogin />
      </template>
      <template v-if="isAgentReset">
        <AuthRestorePassword :token="token" />
      </template>
      <template v-if="isEmployer">
        <AuthEmployerLogin/>
      </template>
      <template v-if="isEmployerRegister">
        <AuthEmployerRegister/>
      </template>
    </div>
  </div>
</template>

<script>
  import {setMetaRobots} from '@/helpers/metaRobots'
  import {removeCanonicalTag} from '@/router/common/setCanonical'
  import AuthAgentLogin from '@/components/authSecondary/AuthAgentLogin'
  import AuthEmployerLogin from '@/components/authSecondary/AuthEmployerLogin'
  import AuthEmployerRegister from '@/components/authSecondary/AuthEmployerRegister'
  import AuthRestorePassword from '@/components/authSecondary/AuthRestorePassword'

  export default {
    name: 'AuthSecondaryPage',
    components: {
      AuthAgentLogin,
      AuthEmployerLogin,
      AuthEmployerRegister,
      AuthRestorePassword,
    },
    data() {
      return {}
    },
    computed: {
      isAgent() {
        return this.isRouteNameMixin('auth-agent')
      },
      isEmployer() {
        return this.isRouteNameMixin('auth-employer')
      },
      isEmployerRegister() {
        return this.isRouteNameMixin('auth-employer-register')
      },
      isAgentReset() {
        return this.isRouteNameMixin('auth-agent-reset')
      },
      token() {
        return this.$route.query.reset_token
      }
    },
    methods: {},
    created() {
      setMetaRobots('noindex, follow')
      removeCanonicalTag()
    }
  }
</script>

<style lang="less">

</style>
